import {
  microsoftAuthApiRef,
  configApiRef,
  useApi,
} from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { navModule } from './modules/nav';

const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => {
      const configApi = useApi(configApiRef);
      const showGuestLogin =
        configApi.getOptionalBoolean('app.showGuestLogin') ?? false;
      return (
        <SignInPage
          {...props}
          providers={[
            ...(showGuestLogin ? ['guest' as const] : []),
            {
              id: 'microsoft-auth-provider',
              title: 'Microsoft',
              message: 'Logga in med ditt Samhall-konto',
              apiRef: microsoftAuthApiRef,
            },
          ]}
        />
      );
    },
  },
});

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    createFrontendModule({
      pluginId: 'app',
      extensions: [signInPage],
    }),
  ],
});
